import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Avatar,
  Chip,
  Badge,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
  Circle,
} from '@mui/icons-material';
import { useTelegramStatus } from '../hooks/useTelegram';
import config from '../config';

const Navbar = ({ onMenuClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { status, loading } = useTelegramStatus();

  // Determine connection status
  const isConnected = status?.is_logged_in || status?.connected || false;
  const userName = status?.user || 'User';

  return (
    <AppBar
      position="static"
      sx={{
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        boxShadow: 'none',
        position: 'fixed',
        top: 0,
        zIndex: theme.zIndex.drawer + 1,
        width: '100%',
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          onClick={onMenuClick}
          sx={{ 
            mr: 2,
            color: 'text.primary'
          }}
        >
          <MenuIcon />
        </IconButton>
        
        <Box sx={{ 
          flexGrow: 1, 
          display: 'flex', 
          alignItems: 'center', 
          gap: isMobile ? 1 : 2,
          overflow: 'hidden'
        }}>
          <Typography 
            variant={isMobile ? "subtitle1" : "h6"} 
            sx={{ 
              fontWeight: 600,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {config.APP_NAME}
          </Typography>
          
          {!isMobile && (
            <Chip
              icon={
                <Circle sx={{ 
                  fontSize: 12, 
                  color: isConnected ? '#10b981' : '#ef4444' 
                }} />
              }
              label={loading ? 'Checking...' : isConnected ? 'Connected' : 'Disconnected'}
              size="small"
              sx={{
                bgcolor: isConnected ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                color: isConnected ? '#10b981' : '#ef4444',
                fontWeight: 500,
                flexShrink: 0,
              }}
            />
          )}
        </Box>

        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: isMobile ? 1 : 2
        }}>
          {!isMobile && (
            <IconButton>
              <Badge badgeContent={0} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
          )}
          
          {!isMobile && (
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: 500,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: 120
              }}
            >
              {userName}
            </Typography>
          )}
          
          <Avatar
            sx={{
              bgcolor: 'primary.main',
              width: isMobile ? 32 : 40,
              height: isMobile ? 32 : 40,
              cursor: 'pointer',
              fontSize: isMobile ? '0.875rem' : '1rem',
            }}
            title={userName}
          >
            {userName.charAt(0).toUpperCase()}
          </Avatar>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;